export default "__VITE_ASSET__DY3s2BMA__"